"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var Page_1 = require("../Page");
var react_1 = require("@monaco-editor/react");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../Types");
var operators_1 = require("rxjs/operators");
var CalculateInteractionPage = /** @class */ (function (_super) {
    __extends(CalculateInteractionPage, _super);
    function CalculateInteractionPage(props) {
        var _this = _super.call(this, props) || this;
        _this.renderPageContent = function () {
            return ((0, jsx_runtime_1.jsxs)("div", { className: "panel-border position-absolute p-3", style: {
                    left: '2vw',
                    width: '96vw'
                }, children: [(0, jsx_runtime_1.jsx)(react_1.DiffEditor, { height: "78vh", width: "100%", language: "json", className: "compare-interaction", options: {
                            originalEditable: true,
                            readOnly: true
                        }, original: "", theme: _this.state.currentTheme, modified: _this.state.modifiedEditorValue, onMount: function (editor, monaco) {
                            var originalEditor = editor.getOriginalEditor();
                            editor.getOriginalEditor().focus();
                            _this.setState({
                                getOriginalValue: function () { return originalEditor.getValue(); }
                            });
                            var timeout;
                            originalEditor.onDidChangeModelContent(function () {
                                if (timeout) {
                                    clearTimeout(timeout);
                                }
                                timeout = setTimeout(function () {
                                    var currentValue = originalEditor.getValue();
                                    if (currentValue.trim() === "") {
                                        _this.setState({ currentTheme: 'withoutDiff' });
                                    }
                                }, 300);
                            });
                        } }), (0, jsx_runtime_1.jsx)("button", { onClick: _this.calculate, className: "btn btn-primary mt-2 d-block w-100", children: "Calculate interaction" })] }));
        };
        _this.defineCustomTheme = function (monacoInstance) {
            var withoutDiff = {
                base: 'vs',
                inherit: true,
                rules: [],
                colors: {
                    'editor.background': '#ffffff',
                    'editorCursor.foreground': '#000000',
                    "editor.selectionBackground": "#88000015",
                    "editor.inactiveSelectionBackground": "#88000015",
                    'diffEditor.insertedTextBackground': '#ffffff',
                    'diffEditor.removedTextBackground': '#ffffff'
                }
            };
            monacoInstance.editor.defineTheme('withoutDiff', withoutDiff);
        };
        _this.calculate = function () {
            try {
                _this.setState({ isLoading: true });
                var JSONValue = JSON.parse(_this.state.getOriginalValue());
                _this.supportPortalService.calculateInteraction(JSONValue)
                    .pipe((0, operators_1.finalize)(function () { return _this.setState({ isLoading: false, currentTheme: 'vs' }); }))
                    .subscribe(function (interaction) {
                    _this.setState({
                        modifiedEditorValue: JSON.stringify(interaction, null, "    ")
                    });
                });
            }
            catch (error) {
                console.error('Invalid JSON format:', error);
                _this.setState({
                    currentTheme: 'withoutDiff',
                    isLoading: false
                });
            }
        };
        _this.state = {
            isLoading: false,
            getOriginalValue: function () { return ""; },
            modifiedEditorValue: "This value will be changed with the calculated value",
            currentTheme: 'withoutDiff',
        };
        return _this;
    }
    CalculateInteractionPage.prototype.componentDidMount = function () {
        var _this = this;
        react_1.loader.init().then(function (monacoInstance) {
            _this.defineCustomTheme(monacoInstance);
        }).catch(function (error) {
            console.error('An error occurred during Monaco initialization: ', error);
        });
    };
    CalculateInteractionPage.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)(Page_1.default, { title: "Calculate interaction", isLoading: this.state.isLoading, children: this.renderPageContent() }));
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], CalculateInteractionPage.prototype, "supportPortalService", void 0);
    CalculateInteractionPage = __decorate([
        components_1.authorize,
        (0, components_1.role)("Administrator"),
        __metadata("design:paramtypes", [Object])
    ], CalculateInteractionPage);
    return CalculateInteractionPage;
}(React.Component));
exports.default = CalculateInteractionPage;
//# sourceMappingURL=CalculateInteractionPage.js.map